import React from "react";

import { styles } from "@common/styles";

const listItemStyle = { ...styles.listItem, flex: "8" };
const companyItemStyle = { ...listItemStyle, width: "35%", flex: "7" };
const clickableListItemStyle = { ...listItemStyle, cursor: "pointer" };
const clickableCompanyItemStyle = {
  ...companyItemStyle,
  cursor: "pointer"
};
const activeItemStyle = { ...listItemStyle, width: "10%", flex: "2" };
const clickableActiveItemStyle = { ...activeItemStyle, cursor: "pointer" };
const editLinkStyle = {
  ...listItemStyle,
  justifyContent: "flex-end",
  width: "15%",
  flex: "3"
};

export interface IUserListHeaderProps {
  reverseOrder: boolean;
  handleSortUsers: (name: string, reverseOrder: boolean) => void;
}

const userListHeader = ({
  reverseOrder,
  handleSortUsers
}: IUserListHeaderProps) => (
  <div style={styles.headerRow as any}>
    <div
      style={clickableListItemStyle as any}
      onClick={() => handleSortUsers("Name", reverseOrder)}
      title="Sorter etter navn"
    >
      Navn
    </div>
    <div
      style={clickableCompanyItemStyle as any}
      onClick={() => handleSortUsers("DepartmentName", reverseOrder)}
      title="Sorter etter forhandler"
    >
      Forhandler
    </div>
    <div
      style={clickableActiveItemStyle as any}
      onClick={() => handleSortUsers("IsActive", reverseOrder)}
      title="Sorter etter aktiv-status"
    >
      Aktiv?
    </div>
    <div style={editLinkStyle as any} />
  </div>
);

export default userListHeader;
